import { Illustration, Text } from "@clipboard-health/ui-components";
import { Box, CardContent, Stack } from "@mui/material";
import { type Facility } from "@src/appV2/Facilities/types";

import { formatFacilityHourRestrictionText } from "../../utils/formatFacilityHourRestrictionText";
import { ShiftBottomSheetInnerCard } from "./InnerCard";

interface ShiftBottomSheetHourRestrictionsCardProps {
  maxAllowedWorkConsecutiveHours?: Facility["maxAllowedWorkConsecutiveHours"];
  maxAllowedWorkHoursPerWeek?: Facility["maxAllowedWorkHoursPerWeek"];
  preventDoubleShifts?: Facility["preventDoubleShifts"];
}

export function ShiftBottomSheetHourRestrictionsCard(
  props: ShiftBottomSheetHourRestrictionsCardProps
) {
  const { maxAllowedWorkConsecutiveHours, maxAllowedWorkHoursPerWeek, preventDoubleShifts } = props;

  return (
    <ShiftBottomSheetInnerCard intent="warning">
      <CardContent
        sx={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 6,
        }}
      >
        <Stack alignItems="center" spacing={5} sx={{ textAlign: "center", textWrap: "balance" }}>
          <Box alignSelf="stretch" display="flex" justifyContent="center" pb={6}>
            <Illustration type="info" />
          </Box>
          <Text semibold variant="h5">
            This workplace has a booking limit
          </Text>
          <Text color={(theme) => theme.palette.text.secondary} variant="body2">
            {formatFacilityHourRestrictionText({
              maxAllowedWorkConsecutiveHours: maxAllowedWorkConsecutiveHours ?? undefined,
              maxAllowedWorkHoursPerWeek: maxAllowedWorkHoursPerWeek ?? undefined,
              preventDoubleShifts,
            })}
          </Text>
        </Stack>
      </CardContent>
    </ShiftBottomSheetInnerCard>
  );
}
